import React from 'react';
import PropTypes from 'prop-types';
import './MleAdditionModal.scss';
import remove from '../../static/images/remove.png';
import { FormElems } from '../index';
import { ENTITY_TYPE } from '../../utils/constants/commonValues';

const MleAdditionModal = props => {
    const { handleClose, isOpen, handleSubmit, entityList, actions } = props;
    const [selectedData, setSelectedData] = React.useState({});

    const handleRoleSelect = (value, originalData, type) => {

        const isObjectEmpty = Object.keys(originalData).length === 0;

        console.log(value, originalData, type, isObjectEmpty, 'originalData');

        if (!value && isObjectEmpty && type === 'AGGREGATOR') {
            actions.fetchEntityListRequest(ENTITY_TYPE.AGGREGATOR);
            actions.fetchEntityListRequest(ENTITY_TYPE.FRANCHISE);
            actions.fetchEntityListRequest(ENTITY_TYPE.MBE);
            setSelectedData(prev => ({ ...prev, franchise: null, mbe: null }));
        }

        if (type === 'FRANCHISE') {
            setSelectedData(prev => ({ ...prev, mbe: null }));
        } else if (type === 'AGGREGATOR') {
            setSelectedData(prev => ({ ...prev, franchise: null, mbe: null }));
        }
        if (!value && isObjectEmpty && type === 'FRANCHISE') {
            actions.fetchEntityListRequest(ENTITY_TYPE.FRANCHISE);
            actions.fetchEntityListRequest(ENTITY_TYPE.MBE);
        }

        if (value && !isObjectEmpty && originalData.entityType !== 'MBE') {
            actions.fetchEntityHierarchyRequest(
                value,
                'LOWER_COMPLETE',
                originalData.entityType
            );
        }
        setSelectedData(prev => ({ ...prev, [type.toLowerCase()]: value }));
    };

    const handleSearchEnd = (value, entityType) => {
        const filtered =
            entityList[entityType.toLowerCase()]?.filter(item => {
                const key = 'entityCode';
                return item[key]?.toLowerCase().includes(value.toLowerCase());
            }) || [];

        const data = {
            entityName: value,
            entityCode: '',
        };

        if (filtered.length === 0 && value.length >= 3) {
            actions.fetchEntityListRequest(entityType, data);
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay mle-addition">
            <div className={'modal-content'}>
                <div className={'modal-header'}>
                    {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
                    <h2 />
                    <div>
                        <img src={remove} alt="Close" onClick={handleClose} />
                    </div>
                </div>
                <div className={'modal-body'}>
                    <div className={'form-field'}>
                        <h3>Select MLE</h3>
                        <FormElems.SearchSelectEnhanced
                            label={'Select MLE'}
                            data={entityList.mle || []}
                            labelField="name"
                            valueField="entityCode"
                            selected={selectedData.mle}
                            handleChange={(value, originalData) =>
                                handleRoleSelect(value, originalData, 'MLE')
                            }
                            handleSearchEnd={val => handleSearchEnd(val, 'MLE')}
                        />
                    </div>
                    <div className={'form-field'}>
                        <h3>Select Hierarchy</h3>
                        <FormElems.SearchSelectEnhanced
                            label="Select Aggregator"
                            data={entityList.aggregator || []}
                            labelField="name"
                            valueField="entityCode"
                            selected={selectedData.aggregator}
                            handleChange={(value, originalData) =>
                                handleRoleSelect(
                                    value,
                                    originalData,
                                    'AGGREGATOR'
                                )
                            }
                            handleSearchEnd={val => handleSearchEnd(val, 'AGGREGATOR')}
                        />
                        <FormElems.SearchSelectEnhanced
                            label="Select Franchise"
                            data={entityList.franchise || []}
                            labelField="name"
                            valueField="entityCode"
                            selected={selectedData.franchise}
                            handleChange={(value, originalData) =>
                                handleRoleSelect(
                                    value,
                                    originalData,
                                    'FRANCHISE'
                                )
                            }
                            handleSearchEnd={val => handleSearchEnd(val, 'FRANCHISE')}
                        />
                        <FormElems.SearchSelectEnhanced
                            label="Select MBE"
                            data={entityList.mbe || []}
                            labelField="name"
                            valueField="entityCode"
                            selected={selectedData.mbe}
                            handleChange={(value, originalData) =>
                                handleRoleSelect(value, originalData, 'MBE')
                            }
                            handleSearchEnd={val => handleSearchEnd(val, 'MBE')}
                        />
                    </div>
                </div>
                <div className={'modal-footer-mle'}>
                    <FormElems.Button
                        id="next-btn"
                        buttonType="secondary"
                        text="Cancel"
                        handleClick={handleClose}
                    />
                    <FormElems.Button
                        id="next-btn"
                        buttonType="primary"
                        text="Proceed"
                        isDisable={!selectedData.mle}
                        handleClick={() => handleSubmit(selectedData)}
                    />
                </div>
            </div>
        </div>
    );
};

MleAdditionModal.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    handleSubmit: PropTypes.func,
    entityList: PropTypes.object,
    actions: PropTypes.object,
};

export default MleAdditionModal;
